// ===========================================================================
// Module B — High Risk Patient Surveillance
// Constantes y enums del módulo.
// ===========================================================================

/** Locations disponibles en los dumps de DataDashCareManager. */
export const LOCATIONS = [
  { key: "fort_myers", label: "Fort Myers" },
  { key: "fort_pierce", label: "Fort Pierce" },
  { key: "hialeah", label: "Hialeah" },
  { key: "immokalee", label: "Immokalee" },
  { key: "lake_worth", label: "Lake Worth" },
  { key: "lehigh_acres", label: "Lehigh Acres" },
  { key: "lehigh_acres_5705", label: "Lehigh Acres 5705" },
  { key: "naples", label: "Naples" },
  { key: "naples_5262", label: "Naples 5262" },
  { key: "port_st_lucie", label: "Port St. Lucie" },
];

export const DEFAULT_LOCATION = "fort_myers";

/** Tono semántico por health status del dump. */
export const HEALTH_STATUS_META = {
  "End of Life": { tone: "crit" },
  Complex: { tone: "crit" },
  "At Risk": { tone: "warn" },
  Chronic: { tone: "warn" },
  Acute: { tone: "info" },
  Well: { tone: "ok" },
};

/** Bandas del score compuesto de vigilancia. */
export const RISK_BAND = {
  CRITICAL: { label: "Critical", tone: "crit", min: 0.75 },
  ELEVATED: { label: "Elevated", tone: "warn", min: 0.5 },
  WATCH: { label: "Watch", tone: "info", min: 0 },
};

export function riskBandFor(score) {
  if (score >= RISK_BAND.CRITICAL.min) return RISK_BAND.CRITICAL;
  if (score >= RISK_BAND.ELEVATED.min) return RISK_BAND.ELEVATED;
  return RISK_BAND.WATCH;
}

/** Acciones recomendadas que produce el motor de scoring. */
export const RECOMMENDED_ACTIONS = {
  REFER_CM: { label: "Refer to Care Management", tone: "crit" },
  GAP_VISIT: { label: "Schedule gap-closure visit", tone: "warn" },
  COST_REVIEW: { label: "Cost & utilization review with PCP", tone: "warn" },
  TOUCHPOINT: { label: "Routine surveillance touchpoint", tone: "info" },
};
